import CloseIcon from '@mui/icons-material/Close';
import { Dialog, IconButton } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface AgeVerificationRejectedDialogProps {
  open: boolean;
  onClose: () => void;
}

const AgeVerificationRejectedDialog: React.FC<AgeVerificationRejectedDialogProps> = ({ open, onClose }) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      disableEscapeKeyDown
      sx={{ '& .MuiPaper-root': { borderRadius: '12px', width: '100%', maxWidth: '360px', margin: '16px' } }}
    >
      <div className="p-4 flex flex-col gap-3 w-full" onClick={(event: React.MouseEvent<HTMLDivElement>) => event.stopPropagation()}>
        <div className="flex items-start justify-between gap-3">
          <p className="text-black-900 text-lg font-semibold leading-7 whitespace-pre-line">{t('AGE_VERIFICATION_REJECT_TITLE')}</p>
          <IconButton onClick={onClose} size="small" sx={{ padding: '2px' }} aria-label="close">
            <CloseIcon sx={{ width: 24, height: 24, color: '#667085' }} />
          </IconButton>
        </div>
        <p className="text-gray-600 text-sm leading-5 whitespace-pre-line">{t('AGE_VERIFICATION_REJECT_MESSAGE')}</p>
      </div>
    </Dialog>
  );
};

export default AgeVerificationRejectedDialog;
